<template>
  <div>
    <v-toolbar dark>
      <v-toolbar-title>
        {{$t('Register.ApplicationRank.Title')}} {{ getApplicationKeyRanking.application.user.first_name }}!
      </v-toolbar-title>
    </v-toolbar>
    <v-card-text>
      {{$t('Register.ApplicationRank.Msg[0]')}}{{getApplicationKeyRanking.rank}}<br>
      {{$t('Register.ApplicationRank.Msg[1]')}} <br>
      <span v-for="project in getApplicationKeyRanking.application.user.projects" :key="project.id">
        {{ project.project.name }} <br>
      </span>
      <br>
    </v-card-text>
    <v-card-actions>
      <v-btn color="green" @click="$router.push({ name: 'Home'})">{{$t('Register.ApplicationRank.Button')}}</v-btn>
    </v-card-actions>
  </div>
</template>
<script>
import {
  mapGetters
} from 'vuex';
// import StandardCard from '@/components/StandardComponents/StandardCard.component.vue'
import store from '@/store/index'
export default {
  name: 'ApplicationRank',
  components: {
    // StandardBadge
  },
  beforeRouteEnter (to, from, next) {
    store.dispatch('Application/requestApplicationRankingByKey', to.params.key).then(() => {
      next();
    });
  },
  computed: {
    ...mapGetters('Application',[
      'getApplicationKeyRanking'
    ])
  },
  methods: {

  }
}
</script>

<style lang="css" scoped>

</style>
